/*  MUI  */
import { useTheme } from '@mui/material/styles';

/*  NPM  */
// eslint-disable-next-line import/no-duplicates
import { format, getDay, parse, startOfWeek } from 'date-fns';
// eslint-disable-next-line import/no-duplicates
import { enUS } from 'date-fns/locale';

/*  React  */
import React from 'react';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';

const locales = {
    'en-US': enUS
};

const localizer = dateFnsLocalizer({
    format,
    getDay,
    locales,
    parse,
    startOfWeek
});

export const eventStyleGetter = (event, theme) => {
    let backgroundColor = '';
    let borderColor = '';
    if (event.resource) {
        if (event.resource.type === 'month') {
            backgroundColor = theme.palette.bigCalendar.monthly.background;
            borderColor = theme.palette.bigCalendar.monthly.border;
        }
        if (event.resource.type === 'renew') {
            backgroundColor = theme.palette.bigCalendar.renew.background;
            borderColor = theme.palette.bigCalendar.renew.border;
        }
    }
    const style = {
        backgroundColor,
        border: '1px solid',
        borderColor,
        borderRadius: '6px',
        color: theme.palette.text.primary,
        display: 'block',
        opacity: 1,
        padding: 0
    };
    return {
        style
    };
};

// To show only label and not the navigation buttons
const CustomToolbarLabelOnly = (props) => (
    <div className="rbc-toolbar">
        <span className="rbc-toolbar-label">{props.label}</span>
    </div>
);

export const BigCalendar = ({
    date,
    events,
    display,
    drillDown,
    height = '850px',
    toolbar = true,
    updateEvents,
    views = ['month']
}) => {
    const theme = useTheme();
    return (
        <Calendar
            components={{
                ...(!toolbar ? { toolbar: CustomToolbarLabelOnly } : {})
            }}
            {...(date ? { defaultDate: date } : {})}
            eventPropGetter={(event) => eventStyleGetter(event, theme)}
            events={events}
            formats={{
                dateFormat: 'd',
                weekdayFormat: 'ccc'
            }}
            localizer={localizer}
            onDrillDown={drillDown}
            onRangeChange={updateEvents}
            onSelectEvent={(event) => display(event)}
            style={{ height }}
            views={views}
            toolbar
            tooltipAccessor={(event) => event.appName}
        />
    );
};
